<template>
    <client-page>

        <sub-visual
        sh="What We Do"
        tabActive="Safety Management"
        bg="/images/sub/visual/sv4.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <div class="page-tit-wrap">
                    <h2 class="page-tit">
                        Safety Management
                    </h2>
                    <p>
                        We are establishing an occupational Health and Safety Management System for worker safety. <br>
                        Consulting and requirements for periodic management of occupational safety management are being updated.
                    </p>
                </div>
            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <sub-line-layout tit="Safety Management System">
                    <v-img src="/images/sub/wwd/management/management-img-en.png" max-width="950" class="mx-auto mb-90 mb-md-120 mb-lg-140 d-none d-lg-block"></v-img>
                    <v-img src="/images/sub/wwd/management/management-img-mo-en.png" max-width="480" class="mx-auto mb-90 mb-md-120 mb-lg-140 d-block d-lg-none"></v-img>
                    <v-row class="my-n10 my-lg-n40">

                        <sub-icon-box
                        icon="/images/sub/wwd/management/management-icon1.png"
                        iconWidth="50"
                        tit="Establishment and Maintenance of Safety & Health Management System">
                            <p class="font-size-14 font-size-lg-16 color-grey-2c">
                                Familiarity with the manual. <br>
                                According to the company’s safety & health organization, business size and process characteristics
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/management/management-icon2.png"
                        iconWidth="53"
                        tit="Voluntary Industrial Accident Prevention">
                            <p class="font-size-14 font-size-lg-16 color-grey-2c">
                                Workers present their opinions on safety and health Identification of on-site risk factors, <br class="d-none d-md-block">
                                establishment of improvement plans and confirmation of participation
                                in operation of suggestions by workers
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/management/management-icon3.png"
                        iconWidth="51"
                        tit="Safety & Health Education and Training">
                            <p class="font-size-14 font-size-lg-16 color-grey-2c">
                                Safety and Health management system education for worker safety Identify items to <br class="d-none d-md-block">
                                identify risk factors in the field. Action Priority decision, control and establishment of control plan.
                            </p>
                        </sub-icon-box>

                        <sub-icon-box
                        icon="/images/sub/wwd/management/management-icon4.png"
                        iconWidth="54"
                        tit="Safety and Health Related Laws Compliance with Requirements">
                            <p class="font-size-14 font-size-lg-16 color-grey-2c">
                                Serious Accident Punishment Act and Safety & Health Management System. <br>
                                According to the purpose of construction, key factors and the need for implementation. <br>
                                Establishment and implementation of work procedures for each key element.
                            </p>
                        </sub-icon-box>

                    </v-row>
                </sub-line-layout>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/en/sub/sub-line-layout.vue";
import SubIconBox from "@/components/client/en/sub/sub-icon-box.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
        SubIconBox,
    },
};
</script>

<style lang="scss" scoped>
</style>